import React from "react";

export enum EventButtonVariant {
  PRIMARY_BLACK = "primary_black",
  PRIMARY_WHITE = "primary_white",
  SECONDARY = "secondary",
  SUCCESS = "success",
  TRANSPARENT = "transparent",
  TIMER = "timer",
  GRADIENT = "gradient",
  DISABLED = "disabled",
}

interface EventButtonProps {
  children: React.ReactNode;
  onClick: () => void;
  variant?: EventButtonVariant;
  disabled?: boolean;
  className?: string;
  icon?: string;
}

const EventButton: React.FC<EventButtonProps> = ({
  children,
  onClick,
  variant = EventButtonVariant.PRIMARY_BLACK,
  disabled = false,
  className = "",
  icon,
}) => {
  const getVariantClasses = () => {
    switch (variant) {
      case EventButtonVariant.PRIMARY_BLACK:
        return "bg-black text-white";
      case EventButtonVariant.PRIMARY_WHITE:
        return "bg-white text-black";
      case EventButtonVariant.SECONDARY:
        return "bg-black text-white";
      case EventButtonVariant.SUCCESS:
        return disabled
          ? "bg-gray-600 text-gray-300 cursor-not-allowed"
          : "bg-green-500 text-white";
      case EventButtonVariant.TRANSPARENT:
        return "bg-transparent text-white";
      case EventButtonVariant.TIMER:
        return "bg-black text-white/50";
      case EventButtonVariant.GRADIENT:
        return "bg-gradient-to-r from-[#3DFFCB] to-[#84C5FF] text-black";
      case EventButtonVariant.DISABLED:
        return "bg-black/60 text-white cursor-not-allowed";
      default:
        return "bg-black/60 text-white";
    }
  };

  const baseClasses =
    "font-medium rounded-full transition-colors flex items-center justify-center gap-2";
  const variantClasses = getVariantClasses();

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={`py-3 px-6 text-base ${baseClasses} ${variantClasses} ${className}`}
    >
      {icon && <span>{icon}</span>}
      {children}
    </button>
  );
};

EventButton.defaultProps = {
  variant: EventButtonVariant.PRIMARY_BLACK,
  disabled: false,
  className: "",
  icon: undefined,
};

export default EventButton;
